import React, { useState, useEffect } from "react";
import Loading from "./Loading";
import Tours from "./Tours";
// ATTENTION!!!!!!!!!!
// I SWITCHED TO PERMANENT DOMAIN
const url = "https://course-api.com/react-tours-project";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [tours, setTours] = useState([]);

  const removeTour = (id) => {
    const newTours = tours.filter((tour) => tour.id !== id);
    setTours(newTours);
  };

  const getToursData = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(url);
      const toursData = await response.json();
      console.log(toursData);
      setTours(toursData);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.error(e.message);
    }
  };

  useEffect(() => {
    getToursData();
  }, []);

  if (tours.length === 0) {
    return (
      <main>
        <div className="title">
          <h2>No Tours Left</h2>
          <button className="btn" onClick={getToursData}>
            Refresh tours
          </button>
        </div>
      </main>
    );
  }
  return (
    <section className="container">
      <main>
        {isLoading ? (
          <Loading />
        ) : (
          <Tours tours={tours} removeTour={removeTour} />
        )}
      </main>
    </section>
  );
}

export default App;
